import redirectSource from './AvatarRedirect';
export default redirectSource('instagram', 'instagramId');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-avatar/es/sources/Instagram.js
// module id = 635
// module chunks = 0